<template #default>
  <div class="login-container">
    <a-card class="card-wrapper">
      <div class="login-title">Pinpoint Login</div>
      <a-form
        :model="formState"
        name="basic"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
        autocomplete="off"
        @finish="onFinish"
        @finishFailed="onFinishFailed"
      >
        <a-form-item
          label="Username"
          name="username"
          :rules="[{ required: true, message: 'Please input your username!' }]"
        >
          <a-input v-model:value="formState.username" size="large">
            <template #prefix>
              <UserOutlined />
            </template>
          </a-input>
        </a-form-item>

        <a-form-item
          label="Password"
          name="password"
          :rules="[{ required: true, message: 'Please input your password!' }]"
        >
          <a-input-password v-model:value="formState.password" size="large">
            <template #prefix>
              <LockOutlined />
            </template>
          </a-input-password>
        </a-form-item>

        <a-form-item :wrapper-col="{ offset: 0, span: 24 }" class="btn-row">
          <a-button type="primary" html-type="submit" block size="large"
            >Login</a-button
          >
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
// import { ref } from "vue";
import { reactive } from 'vue'
import auth from '@/api/auth'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useCookies } from 'vue3-cookies'
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'

const router = useRouter()
const store = useStore()

const formState = reactive({
  username: '',
  password: '',
})

const { cookies } = useCookies()

const handleLogin = () => {
  auth
    .login({
      userName: formState.username,
      pwd: formState.password,
    })
    .then(async (response) => {
      if (response.status === 200) {
        // Handle successful login
        const token = response.data.accessToken
        store.commit('auth/SET_USER', formState.username)
        store.commit('auth/SET_AUTH', token)
        cookies.set('ut', token)
        cookies.set('ut', token, null, null, 'pinpointfund.com')
        const userPermissionRes = await auth.getUserPermission(token)
        store.commit('auth/SET_ROLE', userPermissionRes.data.data.roleList)
        // Optionally, redirect to another page or store the token
        router.push('/fund')
      } else {
        // Handle login failure
        console.error('Login failed:', response)
      }
    })
    .catch((error) => {
      console.error('Error during login:', error)
    })
}

const onFinish = (values) => {
  console.log('start:', values)
  handleLogin(values.username, values.password)
  console.log('Success:', values)
}
const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo)
}
</script>
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f6fa;
  background-image: url('@/assets/account.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.card-wrapper {
  min-width: 500px;
  max-width: 600px;
  width: 100%;
  padding: 32px 24px 24px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
.login-title {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #222;
  letter-spacing: 2px;
}
.btn-row {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}
</style>
